var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDropdown = function SvgDropdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#BBC0C5",
    xmlns: "http://www.w3.org/2000/svg",
    accessibilityRole: "image"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 11.3334C7.46067 11.3334 6.98876 11.1136 6.58427 10.674L2.20225 5.98537C1.93258 5.69233 1.93258 5.17951 2.20225 4.88647C2.47191 4.59343 2.8764 4.59343 3.14607 4.88647L7.52809 9.64837C7.79775 9.94141 8.20225 9.94141 8.47191 9.64837L12.8539 4.88647C13.1236 4.59343 13.5281 4.59343 13.7978 4.88647C14.0674 5.17951 14.0674 5.61907 13.7978 5.91211L9.41573 10.674C9.01123 11.1136 8.53932 11.3334 8 11.3334Z"
  })));
};
export default SvgDropdown;